(function(){
  function openCartDrawer(triggeredBy) {
    if (typeof window.openDrawer === 'function') {
      window.openDrawer();
    } else {
      console.warn("⚠️ openDrawer non trovato, drawer custom non caricato");
    }
  }

  function intercept(e) {
    const target = e.target.closest('#cart-icon-target, .header__icon--cart, a[href="/cart"]');
    if (!target) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    console.log("Click intercettato sul carrello");
    openCartDrawer(target);
  }

  document.addEventListener('click', intercept, true);
  document.addEventListener('cart:updated', () => openCartDrawer());
})();
